<template>
	<v-tooltip :text="iso.getName(lang) || lang">
		<template v-slot:activator="{ props }">
			<span
				v-bind="props"
				:class="{ fi: true, [`fi-${flagCode}`]: true }"
				style="border-radius: 15%; scale: 0.8; margin-right: 2px"
			></span>
		</template>
	</v-tooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";
import iso from "iso-639-1";

const compProps = defineProps<{
	lang: string;
}>();
const flagCode = computed(() => {
	// map language code to flag code
	if (compProps.lang === "en") return "gb"; // English -> Great Britain
	else if (compProps.lang === "zh") return "cn"; // Chinese -> China
	else if (compProps.lang === "hi") return "in"; // Hindu -> India
	else if (compProps.lang === "ar") return "ae"; // Arabic -> United Arab Emirates
	else if (compProps.lang === "bn") return "bd"; // Bengali -> Bangladesh
	else if (compProps.lang === "ja") return "jp"; // Japanese -> Japan
	else if (compProps.lang === "ko") return "kr"; // Korean -> South Korea
	else if (compProps.lang === "da") return "dk"; // Danish -> Denmark
	else if (compProps.lang === "el") return "gr"; // Greek -> Greece
	else if (compProps.lang === "cs") return "cz"; // Czech -> Czech Republic
	else if (compProps.lang === "uk") return "ua"; // Ukrainian -> Ukraine
	else if (compProps.lang === "sv") return "se"; // Swedish -> Sweden
	else if (compProps.lang === "et") return "ee"; // Estonian -> Estonia
	else if (compProps.lang === "bs") return "ba"; // Bosnian -> Bosnia and Herzegovina
	else if (compProps.lang === "ms") return "my"; // Malai -> Malaysia
	else if (compProps.lang === "sr") return "rs"; // Serbian -> Serbia
	else if (compProps.lang === "sl") return "si"; // Slovenian -> Slovenia
	else if (compProps.lang === "tl") return "ph"; // Tagalog -> Philippines
	else if (compProps.lang === "ta") return "lk"; // Tamil -> Sri Lanka
	else if (compProps.lang === "ur") return "pk"; // Urdu -> Pakistan
	else if (compProps.lang === "vi") return "vn"; // Vietnamese -> Vietnam
	return compProps.lang;
});
</script>
